import { DownloadIcon } from '@phosphor-icons/react';
import { useState } from 'react';

import { LinkButton } from 'components/button/ButtonLink';
import { TimeFrame } from 'components/time-frame/time-frame';
import { TimeFrameState } from 'components/time-frame/types';
import {
  SustainabilityAveragesGrid,
  SustainabilityTotalsGrid,
} from 'src/app/sustainability/components/SustainabilityMetricCard';

import { useCustomerSustainabilityReporting } from '../../models';
import { useCustomer } from './customerContext';

export const CustomerSustainabilityReportingPage = () => {
  const { customer } = useCustomer();
  const [timeFrame, setTimeFrame] = useState<null | TimeFrameState>(null);
  const { data } = useCustomerSustainabilityReporting(
    customer.id,
    timeFrame ? { startDate: timeFrame.startDate, endDate: timeFrame.endDate } : null,
  );

  const results = data ?? {
    totalOrders: 0,
    totalDistance: 0,
    totalWeight: 0,
    totalEmissions: 0,
  };

  return (
    <div>
      <div className="flex justify-between items-end px-8">
        <div>
          <LinkButton
            to={`/api/customer-portal/sustainability-report.pdf?customerId=${customer.id}&startDate=${timeFrame?.startDate || ''}&endDate=${timeFrame?.endDate || ''}`}
            target="_blank"
            iconLeft={<DownloadIcon className="w-4 h-4 mr-2" />}
          >
            Download
          </LinkButton>
        </div>

        <div>
          <TimeFrame onChange={setTimeFrame} />
        </div>
      </div>

      <div className="p-8">
        <div className="heading-three mb-4">Totaal</div>

        <SustainabilityTotalsGrid results={results} className="mb-8" />

        <div className="heading-three mb-4">Gemiddelde per order</div>

        <SustainabilityAveragesGrid results={results} />
      </div>
    </div>
  );
};
